import { render } from "./Device.vue?vue&type=template&id=680fa88a"
import script from "./Device.vue?vue&type=script&lang=js"
export * from "./Device.vue?vue&type=script&lang=js"

import "./Device.vue?vue&type=style&index=0&id=680fa88a&lang=scss"
script.render = render

export default script